import { IconButton } from "@mui/material";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";

export const groupColumns = ({
  setSortBy,
  setIsDescending,
  isDescending,
  handleEditGroup,
  handleSelectAll,
  selectedIds,
  handleSelect,
  handleDeleteGroup,
  handleViewGroupUsers,
}) => [
  {
    id: "select",
    header: () => (
      <input
        type="checkbox"
        onChange={handleSelectAll}
        checked={selectedIds.length > 0}
      />
    ),
    cell: (info) => (
      <input
        type="checkbox"
        checked={selectedIds.includes(info.row.original.id)}
        onChange={() => handleSelect(info.row.original.id)}
      />
    ),
    width: "5%",
  },
  {
    id: "name",
    header: "Group Name",
    accessorKey: "name",
    width: "25%",
    cell: (info) => info.getValue(),
  },
  {
    id: "userCount",
    header: "Users",
    accessorKey: "userCount",
    width: "15%",
    cell: (info) => info.getValue(),
  },
  {
    id: "actions",
    header: "Actions",
    width: "20%",
    cell: (info) => (
      <>
        <IconButton
          onClick={() =>
            handleViewGroupUsers(info.row.original.id, info.row.original.name)
          }
          title="View users in this group"
        >
          <VisibilityIcon />
        </IconButton>
        <IconButton
          onClick={() => handleEditGroup(info.row.original.id)}
          title="Edit group"
        >
          <EditIcon />
        </IconButton>
        <IconButton
          onClick={() => handleDeleteGroup(info.row.original.id)}
          title="Delete group"
        >
          <DeleteIcon />
        </IconButton>
      </>
    ),
  },
];
